import Axios from "axios";
import { WidgetConfiguration } from "@/interfaces/widgetConfiguration";
import { WidgetState } from "@/interfaces/widgetState";
import { WidgetPayload } from "@/interfaces/widgetPayload";

export class WidgetService {
    public static async getDefaultState(type: string, token: string) {
        const uri = `/api/widget/by_type/${type}`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data.default_state;
    }

    public static async parsePayload(
        config: WidgetConfiguration<WidgetState, WidgetPayload>,
        payload: WidgetPayload,
        token: string
    ): Promise<WidgetConfiguration<WidgetState, WidgetPayload>> {
        const uri = "/api/widget/parser";
        const response = await Axios.post(
            uri,
            {
                config,
                payload,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data.state;
    }
}
